import React, { useRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import SEO from '../../components/SEO';
import Layout from '../../components/Layout';
import Container from '../../components/Container';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import { FormattedHTMLMessage, Link, useIntl } from 'gatsby-plugin-intl';
import GeneralBanner from '../../components/GeneralBanner';
import ScrollContainer from 'react-indiana-drag-scroll';
import IndividualsPortfolio from '../../components/IndividualsPortfolio';
import IndividualsDisclaimer from '../../components/IndividualsDisclaimer';

const StartEndPadding = () => {
  return (
    <div
      css={css`
        flex: 0 0 auto;
        display: block;
        width: 20px;
        ${Desktop} {
          display: none;
        }
      `}
    ></div>
  );
};

const HowWeInvestPage = () => {
  const intl = useIntl();
  const portfolioRef = useRef(null);
  // window.onscroll = function() {
  //   var view = window.innerHeight;
  //   var posTop = document.documentElement.scrollTop;
  //   Array.prototype.forEach.call(
  //     document.querySelectorAll(".js-fade"),
  //     function(e) {
  //       var top = e.offsetTop;
  //       if (posTop + view - top - 200 > 0) {
  //         //png has show
  //         var opac = (posTop + view - top - 200) / 100 + 0.1;
  //         e.style.opacity = opac;
  //       } else {
  //         //png not show
  //         e.style.opacity = 0.1;
  //       }
  //     }
  //   );
  // };

  const data = useStaticQuery(graphql`
    query {
      one: file(relativePath: { eq: "how-we-invest/1.png" }) {
        childImageSharp {
          fluid(maxWidth: 270) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      two: file(relativePath: { eq: "how-we-invest/2.png" }) {
        childImageSharp {
          fluid(maxWidth: 270) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      three: file(relativePath: { eq: "how-we-invest/3.png" }) {
        childImageSharp {
          fluid(maxWidth: 270) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      four: file(relativePath: { eq: "how-we-invest/4.png" }) {
        childImageSharp {
          fluid(maxWidth: 270) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  return (
    <Layout footerBlank>
      <SEO
        title={intl.formatMessage({ id: 'how-we-invest.title' })}
        description={intl.formatMessage({
          id: 'how-we-invest.description',
        })}
        keywords={intl.formatMessage({ id: 'how-we-invest.keywords' })}
      />
      <GeneralBanner>
        <FormattedHTMLMessage id='how-we-invest.banner.title' />
      </GeneralBanner>
      <Container
        css={css`
          margin-top: 100px;
          ${Desktop} {
            margin-top: 200px;
          }
        `}
      >
        <h1
          css={css`
            width: 100%;
            text-align: left;
            ${Tablet} {
              text-align: center;
            }
          `}
        >
          <FormattedHTMLMessage id='how-we-invest.research.title' />
        </h1>
        <h5
          css={css`
            width: 100%;
            text-align: left;
            ${Tablet} {
              text-align: center;
            }
            ${Desktop} {
              padding: 0px 160px;
            }
          `}
        >
          <FormattedHTMLMessage id='how-we-invest.research.text' />
        </h5>
      </Container>

      <Container
        css={css`
          margin-top: 50px;
          ${Tablet} {
            margin-top: 100px;
          }
        `}
      >
        {['use', 'put', 'make'].map((section) => {
          return (
            <div
              key={section}
              css={css`
                width: 100%;
                display: flex;
                margin-bottom: 40px;
                flex-direction: column;
                ${Tablet} {
                  margin-bottom: 85px;
                  flex-direction: row;
                  align-items: center;
                }
              `}
            >
              <img
                src={`/how-we-invest/${section}.png`}
                className='js-fade'
                css={css`
                  width: 170px;
                  height: 170px;
                  flex: 0 0 170px;
                  margin-bottom: 20px;
                  ${Tablet} {
                    margin-right: 40px;
                    margin-bottom: 0px;
                  }
                  ${Desktop} {
                    width: 250px;
                    height: 250px;
                    flex: 0 0 250px;
                  }
                `}
              />
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  flex: 1;
                `}
              >
                <h1
                  css={css`
                    font-size: 20px;
                    line-height: 25px;
                    ${Tablet} {
                      font-size: 25px;
                      line-height: 30px;
                    }
                    ${Desktop} {
                      font-size: 35px;
                      line-height: 40px;
                    }
                  `}
                >
                  <FormattedHTMLMessage id={`how-we-invest.${section}.title`} />
                </h1>
                <h5
                  css={css`
                    margin-bottom: 0px;
                  `}
                >
                  <FormattedHTMLMessage id={`how-we-invest.${section}.text`} />
                </h5>
              </div>
            </div>
          );
        })}
      </Container>
      <Container
        css={css`
          margin-top: 100px;
        `}
      >
        <h1
          css={css`
            width: 100%;
            text-align: left;
            ${Tablet} {
              text-align: center;
            }
          `}
        >
          <FormattedHTMLMessage id='how-we-invest.how.title' />
        </h1>
        <video
          css={css`
            width: 100%;
            display: none;
            ${Tablet} {
              display: block;
            }
          `}
          src={`/how-we-invest/video/web-${intl.locale}.mp4`}
          autoPlay
          muted
          loop
        />
        <video
          css={css`
            max-width: 400px;
            width: 100%;
            ${Tablet} {
              display: none;
            }
          `}
          src={`/how-we-invest/video/mobile-${intl.locale}.mp4`}
          autoPlay
          muted
          loop
        />
      </Container>
      <Container
        css={css`
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          text-align: left;
          ${Tablet} {
            text-align: center;
          }
          ${Desktop} {
            margin-top: 150px;
          }
        `}
      >
        <h1>
          <FormattedHTMLMessage id='individuals.try.title' />
        </h1>
        <h5
          css={css`
            ${Desktop} {
              padding: 0px 135px;
            }
          `}
        >
          <FormattedHTMLMessage id='individuals.try.text' />
          <br />
          <IndividualsDisclaimer />
        </h5>
      </Container>
      <div ref={portfolioRef} style={{ marginBottom: '163px' }}>
        <IndividualsPortfolio />
      </div>
      <Container
        css={css`
          margin-top: 100px;
          width: 100% !important;
          padding: 0px;
        `}
      >
        <h1
          css={css`
            width: 100%;
            margin-left: 20px;
            margin-right: 20px;
            text-align: left;
            ${Tablet} {
              margin-left: 0px;
              margin-right: 0px;
              text-align: center;
            }
          `}
        >
          <FormattedHTMLMessage id='how-we-invest.learn.title' />
        </h1>
        <ScrollContainer>
          <div
            css={css`
              display: flex;
              flex-wrap: nowrap;
              justify-content: flex-start;
              ${Tablet} {
                justify-content: center;
              }
            `}
          >
            {['one', 'two', 'three', 'four'].map((text, index) => {
              return (
                <Link
                  key={text}
                  to={`/blog/${
                    { one: 17, two: 49, three: 243, four: 158 }[text]
                  }`}
                  css={css`
                    flex-shrink: 0;
                    flex-grow: 0;
                    width: 140px;
                    height: 160px;
                    background: #f2f2f2;
                    border-radius: 20px;
                    z-index: 0;
                    overflow: hidden;
                    box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.3);
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    margin: 20px 0px;
                    margin-left: 20px;
                    ${Tablet} {
                      margin: 20px 12px;
                      width: 160px;
                      height: 180px;
                    }
                    ${Desktop} {
                      width: 270px;
                      height: 290px;
                      margin: 20px 10px;
                    }
                  `}
                >
                  <div
                    css={css`
                      width: 140px;
                      ${Tablet} {
                        width: 160px;
                      }
                      ${Desktop} {
                        width: 270px;
                      }
                    `}
                  >
                    <Img
                      fluid={data[text].childImageSharp.fluid}
                      imgStyle={{ objectFit: 'fill' }}
                      loading='eager'
                    />
                  </div>
                  <h5
                    css={css`
                      margin: 0;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      text-align: center;
                      flex: 1 1 100%;
                      font-weight: bold;
                      font-size: 12px;
                      ${Desktop} {
                        padding: 0px 20px;
                        font-size: 20px;
                        line-height: 1.5;
                      }
                    `}
                  >
                    <FormattedHTMLMessage
                      id={`how-we-invest.learn.text-${index + 1}`}
                    />
                  </h5>
                </Link>
              );
            })}
            <StartEndPadding />
          </div>
        </ScrollContainer>
      </Container>
    </Layout>
  );
};

export default HowWeInvestPage;
